export default "__VITE_ASSET__BSv44hI2__ 720w";